import { useState, useEffect } from 'react'
import throttle from 'lodash/fp/throttle'

const RESIZE_THROTTLE_INTERVAL = 250

function handleThemeBreakpoints(themeBreakpoints) {
  return themeBreakpoints.find(getBreakpoint)?.value || 'desktop'
}

function getBreakpoint(themeBreakpoint) {
  return window.innerWidth >= themeBreakpoint.breakpointMinValue && window.innerWidth < themeBreakpoint.breakpointMaxValue
}

/**
 * This util receives an array of objects where you can configure the max and min values for the viewport and it returns the value associated with it.
 *
 * @param {Object} themeBreakpoints  E.G [{ breakpointMinValue: 320, breakpointMaxValue: 768, value: 'mobile' }]
 * @returns {String} value attached to themeBreakpoints. Default value is 'desktop'.
 */
export default (themeBreakpoints) => {
  const [breakpoint, setBreakpoint] = useState(null)
  const handleResize = throttle(RESIZE_THROTTLE_INTERVAL, () => {
    setBreakpoint(handleThemeBreakpoints(themeBreakpoints))
  })

  useEffect(() => {
    setBreakpoint(handleThemeBreakpoints(themeBreakpoints))
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return breakpoint
}
